import React, { ReactNode } from 'react';
import { BitButtonWrapper } from './styles';

interface BitButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  label: string | ReactNode;
  action: () => void;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
}

export const BitButton = ({ icon, label, action, variant, disabled = false }: BitButtonProps) => {
  return (
    <BitButtonWrapper variant={variant} onClick={() => action()} disabled={disabled}>
      {label}
      {icon}
    </BitButtonWrapper>
  );
};
